import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lume_admin_token") || localStorage.getItem("lume_corp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const FLEET = [
  {
    id: "executive-sedan",
    name: "Business Class",
    capacity: 3, luggage: 3,
    base_rate: 135, hourly_rate: 110,
    image: "https://images.unsplash.com/photo-1589148938909-4d241c91ee52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBibGFjayUyMHNlZGFuJTIwY2FyfGVufDB8fHx8MTc4OTMzOTk4MXww&ixlib=rb-4.1.0&q=85",
    amenities: ["Bottled water — Complimentary", "Device charging", "Sanitized cabin air", "Discreet professional chauffeur"],
    tagline: "The quiet boardroom on wheels",
  },
  {
    id: "luxury-suv",
    name: "Luxury SUV",
    capacity: 6, luggage: 6,
    base_rate: 175, hourly_rate: 140,
    image: "https://images.unsplash.com/photo-1735620731955-b047a7122892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBibGFjayUyMHN1diUyMHZlaGljbGV8ZW58MHx8fHwxNzg5MzM5OTgxfDA&ixlib=rb-4.1.0&q=85",
    amenities: ["Bottled water — Complimentary", "Extended luggage bay", "Sanitized cabin air", "Multi-zone climate"],
    tagline: "Room for the party and the luggage",
    extra_note: "Additional charges may apply for large or specialty SUV configurations.",
  },
  {
    id: "first-class",
    name: "Specialty Vehicle",
    capacity: 3, luggage: 3,
    base_rate: 290, hourly_rate: 250,
    image: "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBibGFjayUyMHNlZGFuJTIwY2FyfGVufDB8fHx8MTc4OTMzOTk4MXww&ixlib=rb-4.1.0&q=85",
    amenities: ["Bottled water — Complimentary", "Champagne service on request", "Acoustic privacy cabin", "Master chauffeur"],
    tagline: "For the moments that must be perfect",
    extra_note: "Additional charges may apply for specialty vehicles.",
  },
  {
    id: "limo",
    name: "Limo Service",
    capacity: 10, luggage: 6,
    base_rate: 0, hourly_rate: 0,
    quote_only: true,
    image: "https://static.prod-images.emergentagent.com/jobs/077e567e-3e6b-4e58-9c18-0784ed9acc6f/images/56252247b013b5f4382d1cb37ffeef22d9409cd4c0efe16a81fa9bc2c64d392d.jpeg",
    amenities: ["Weddings, Sweet 15s/16s, tours & more", "Special pricing — inquiry required", "Bottled water — Complimentary", "Professional chauffeur"],
    tagline: "Luxury limousine service for weddings, Sweet 15s/16s, tours, celebrations, special events, and more.",
    extra_note: "Limo Service is reserved by inquiry only — special pricing.",
  },
  {
    id: "signature-xl",
    name: "Signature XL Service",
    capacity: 15, luggage: 15,
    base_rate: 0, hourly_rate: 0,
    quote_only: true,
    image: "https://static.prod-images.emergentagent.com/jobs/077e567e-3e6b-4e58-9c18-0784ed9acc6f/images/f0ace78be56becc0d4b11c7168ef4abdbe6c16e82409674655ae60928f3dd2ee.jpeg",
    amenities: ["12–15 passenger capacity", "Extended luggage capacity", "Bottled water — Complimentary", "Ideal for groups & productions"],
    tagline: "12–15 passengers · Special pricing available. Request a quote.",
    extra_note: "Signature XL Service is reserved by quote only.",
  },
];

export const SERVICES = [
  { id: "airport-transfer", title: "Airport Transfers", icon: "Plane", subtitle: "Flight-tracked arrivals — JFK, LGA, EWR & Westchester (HPN). 30 min complimentary wait domestic · 45 min international." },
  { id: "point-to-point", title: "Point-to-Point", icon: "MapPin", subtitle: "Door-to-door precision between meetings, residences, and reservations. Additional stops: fees may apply." },
  { id: "hourly", title: "Hourly Service", icon: "Clock", subtitle: "Sedan, SUV, or Van hourly rates — your chauffeur on standby for roadshows, itineraries, and evenings out." },
  { id: "special-event", title: "Special Events", icon: "Sparkles", subtitle: "Weddings, corporate events, celebrations, galas, parties, and more." },
  { id: "long-distance", title: "Long Distance", icon: "Navigation", subtitle: "Long-distance transportation for extended journeys, out-of-area travel, special destinations, and more." },
  { id: "photoshoot", title: "Photoshoot Service", icon: "Camera", subtitle: "Your Vision. Our Vehicle. 2-hour minimum · special pricing, request a quote." },
  { id: "limo", title: "Limo Service", icon: "Crown", subtitle: "Weddings, Sweet 15s/16s, tours, celebrations, special events, and more. Inquire for special pricing." },
];

export const COMFORT_PACKAGE_PRICE = 0;

export const BRAND = {
  phone: "(929) 489-0748",
  phoneRaw: "+19294890748",
  email: "lumeenterprise@gmail.com",
};

export function fmtMoney(n) {
  return `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function estimateFare({ service_type, hours, vehicle }) {
  if (!vehicle) return 0;
  if (service_type === "hourly") {
    const h = Math.max(2, Number(hours || 2));
    return h * vehicle.hourly_rate;
  }
  if (service_type === "long-distance") return vehicle.base_rate * 3.5;
  if (service_type === "special-event") return vehicle.hourly_rate * 4;
  return vehicle.base_rate;
}
